import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {TranslocoService} from '@jsverse/transloco';
import {catchError, combineLatest, map, of} from 'rxjs';

export const preloadAllLanguagesResolver: ResolveFn<boolean> = () => {
  const transloco = inject(TranslocoService);
  const availableLangs = transloco.getAvailableLangs()
  .filter((lang) => lang !== transloco.getDefaultLang() && lang !== transloco.getActiveLang() && lang !== 'terms');
     
  return combineLatest(availableLangs.map((lang) => transloco.load( <string>lang)))
    .pipe(
      catchError((error) => {
        console.warn('Error loading languages:', error);
        return of(true); // Allow navigation to continue even if languages fail to load.
      }),

      map(() => true)
    )
};
